export const getTemplates = ({templates}) => templates.templates;
export const getFilteredTemplates = ({templates}) => templates.filteredTemplates;
export const getCurrentTemplate = ({templates}) => templates.currentTemplate;
export const getTemplatesLoading = ({templates}) => templates.loading;
export const getFilteredTemplatesLoading = ({templates}) => templates.filteredLoading;
export const getTemplatesError = ({templates}) => templates.error;
export const getFilteredTemplatesError = ({templates}) => templates.filteredError;
export const getTemplateSelector = ({templates}) => templates.templateSelector;

